export const getUrlToLoader = (url: string) => {
  return `${url}`;
};
